<template>
  <vs-sidebar click-not-close position-right parent="body" default-index="1" color="primary"
              class="add-new-data-sidebar items-no-padding" spacer v-model="isSidebarActiveLocal">
    <div class="mt-6 flex items-center justify-between px-6">
      <h4>Asignar motorizado</h4>
      <feather-icon icon="XIcon" @click.stop="isSidebarActiveLocal = false" class="cursor-pointer"></feather-icon>
    </div>
    <vs-divider class="mb-0"></vs-divider>

    <component :is="scrollbarTag" class="scroll-area--data-list-add-new" :settings="settings" :key="$vs.rtl">
      <div class="p-6">
        <vs-table v-model="selected" ref="table" pagination :max-items="itemsPerPage"
                  :data="localDetail">

          <template slot="thead">
            <vs-th sort-key="store">Acciones</vs-th>
            <vs-th sort-key="store">Tienda</vs-th>
            <vs-th sort-key="pickupDate">Fecha de recojo</vs-th>
            <vs-th sort-key="pickupDate">Cantidad de paquetes</vs-th>
            <vs-th sort-key="address">Dirección</vs-th>
            <vs-th sort-key="state">Motorizado</vs-th>
          </template>

          <template slot-scope=" {data}">
            <tbody>
              <template v-for="(tr, dataindex) in data">
                <vs-tr v-for="(o, index) in tr.addresses" :key="index" :data="o">
                  <vs-td>
                    <feather-icon icon="TrashIcon" svgClasses="w-5 h-5 hover:text-primary stroke-current"
                                  @click.stop="deleteItem(index, dataindex)"/>
                  </vs-td>
                  <vs-td>
                    <p class="product-name font-medium truncate">{{o.items[0].client.name }}</p>
                  </vs-td>
                  <vs-td>
                    <p class="product-name font-medium truncate">{{ tr.pickupDate}}</p>
                  </vs-td>
                  <vs-td>
                    <p class="product-name font-medium truncate">{{ o.items.length}}</p>
                  </vs-td>
                  <vs-td>
                    <p class="product-name font-medium truncate">{{ o.address}}</p>
                  </vs-td>
                  <vs-td>
                    <v-select :options="dealers"
                              label="displayName"
                              :clearable="false"
                              :dir="$vs.rtl ? 'rtl' : 'ltr'"
                              v-model="o.dealer"
                              class="mb-4 md:mb-0"
                              name="dealer"/>
                  </vs-td>
                </vs-tr>
              </template>
            </tbody>
          </template>
        </vs-table>
      </div>
    </component>
    <div class="flex flex-wrap <items></items>-center p-6" slot="footer">
      <vs-button class="mr-6" @click="submitData" :disabled="!isFormValid || progress">Guardar</vs-button>
      <vs-button type="border" color="danger" @click="isSidebarActiveLocal = false">Cancelar</vs-button>
      <div v-if="progress" style="                                                margin-top: 1rem; width: 100%">
        <vs-progress indeterminate color="primary"></vs-progress>
      </div>
    </div>
  </vs-sidebar>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import trimString from '../../mixins/trimString'
import vSelect from 'vue-select'

import { db, auth, FieldValue } from '@/firebase/firebaseConfig'

export default {
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true
    },
    detail: [],
    dealers: []
  },
  components: {
    VuePerfectScrollbar,
    vSelect
  },
  mixins: [trimString],
  data() {
    return {
      selected: null,
      itemsPerPage: 100,
      isMounted: false,
      settings: {
        // perfectscrollbar settings
        maxScrollbarLength: 60,
        wheelSpeed: .60
      },
      progress: false,
      localDetail: []
    }
  },
  watch: {
    isSidebarActive(val) {
      if (val) {
        // Group detail
        this.localDetail = Object.values(
            this.detail.reduce((acc, curr) => {
              const date = curr.pickUpDate

              if (!acc[date]) {
                acc[date] = {
                  pickUpDate: date,
                  addresses: {}
                }
              }

              if (!acc[date].addresses[curr.pickupAddress.trim()]) {
                acc[date].addresses[curr.pickupAddress.trim()] = []
              }

              acc[date].addresses[curr.pickupAddress.trim()].push(curr)

              return acc
            }, {})).map(group => ({
            pickupDate: group.pickUpDate,
            addresses: Object.entries(group.addresses).map(([address, items]) => ({
              address,
              items,
              dealer: this.dealers.find(d =>
                d.clients?.some(c => c.id === items[0].client.id)
              )
            }))
          }))
        // End
        this.$validator.reset()
      }
    }
  },
  computed: {
    isSidebarActiveLocal: {
      get() {
        return this.isSidebarActive
      },
      set(val) {
        if (!val) {
          this.$emit('closeSidebar')
        }
      }
    },
    isFormValid() {
      return !this.errors.any()
    },
    scrollbarTag() {
      return this.$store.getters.scrollbarTag
    },
    currentPage() {
      if (this.isMounted) {
        return this.$refs.table.currentx
      }
      return 0
    },
    queriedItems() {
      return this.$refs.table ? this.$refs.table.queriedResults.length : this.localDetail.length
    }
  },
  methods: {
    /**
     * Save data in firestore
     * @returns {Promise<void>}
     */
    async submitData() {
      try {
        this.progress = true

        // Validate that no object has the dealer objetc as null
        let flag = this.localDetail.some(ld =>
          ld.addresses?.some(a => a.dealer == null)
        )
        //
        if (!flag) {
          const batch = db.batch()
          for await (const o of this.localDetail) {
            for await (const a of o.addresses) {

              const [y, m, d] = o.pickupDate.split('-') // Data format

              let assignment = {
                client: a.items[0].client,
                address: a.address,
                dealer: a.dealer,
                pickUpDate: new Date(Number(y), Number(m) - 1, Number(d), 0, 1, 0, 0),
                state: true,
                status: 'send',
                uid: auth.currentUser.uid,
                createdAt: FieldValue.serverTimestamp(),
                itemsQuantity: a.items.length
              }

              // Clean object
              delete assignment.dealer.clients
              delete assignment.dealer.updatedAt

              // End

              // Save assignment in firestore
              const doc = await db.collection('assignments').add({
                ...assignment
              })
              // End

              // Save assignment detail
              for await (const item of a.items) {
                const itemDocRef = db.collection('assignments').doc(doc.id).collection('detail').doc()
                batch.set(itemDocRef, {
                  ...item,
                  uid: auth.currentUser.uid,
                  createdAt: FieldValue.serverTimestamp()
                })
              }
              // End
            }
          }

          await batch.commit() // Commit in firestore

          this.$vs.notify({
            color: 'success',
            title: 'Recojos',
            text: 'Se asignaron correctamente los recojos'
          })

          this.$emit('closeSidebar')
          this.$emit('done')
        } else {
          this.$vs.notify({
            color: 'warning',
            title: 'Validación',
            text: 'Todas las entregas deben tener asignado un motorizado'
          })
        }
      } catch (e) {
        this.$vs.notify({
          color: 'warning',
          title: '¡Oh no!',
          text: 'Hubo un error'
        })
      } finally {
        this.progress = false
      }
    },
    /**
     * Delete item
     */
    deleteItem(index, dataIndex) {
      this.localDetail[dataIndex].addresses.splice(index, 1)
    }
  }
}
</script>

<style lang="scss" scoped>
.add-new-data-sidebar {
  ::v-deep .vs-sidebar--background {
    z-index: 52011;
  }

  ::v-deep .vs-sidebar {
    z-index: 52011;
    width: 95vw !important;
    max-width: 95vw;

    .img-upload {
      margin-top: 2rem;

      .con-img-upload {
        padding: 0;
      }

      .con-input-upload {
        width: 100%;
        margin: 0;
      }
    }
  }
}

.scroll-area--data-list-add-new {
  // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
  height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);

  &:not(.ps) {
    overflow-y: auto;
  }
}
</style>
